const updateItems = [
  { date: '2026.07.31', tag: '上新', title: '《暗夜追凶》4K蓝光版正式上线', tagClass: 'bg-accent-500/20 text-accent-400' },
  { date: '2026.07.30', tag: '热播', title: '《星河帝国》第三季第8集同步更新', tagClass: 'bg-primary-500/20 text-primary-400' },
  { date: '2026.07.29', tag: '公告', title: '服务器全面升级，4K播放流畅度提升300%', tagClass: 'bg-secondary-500/20 text-secondary-400' },
  { date: '2026.07.28', tag: '上新', title: '《极限追击》未删减版全网首发', tagClass: 'bg-accent-500/20 text-accent-400' },
  { date: '2026.07.27', tag: '热播', title: '《完美世界》动画版更新至156集', tagClass: 'bg-primary-500/20 text-primary-400' },
  { date: '2026.07.26', tag: '公告', title: '新增日韩剧专区，千部热门剧集上线', tagClass: 'bg-secondary-500/20 text-secondary-400' },
  { date: '2026.07.25', tag: '上新', title: '《深海迷踪》IMAX版本独家上线桃子影院', tagClass: 'bg-accent-500/20 text-accent-400' },
  { date: '2026.07.24', tag: '公告', title: 'iOS客户端V3.2发布，支持画中画功能', tagClass: 'bg-secondary-500/20 text-secondary-400' },
  { date: '2026.07.23', tag: '热播', title: '暑期档专题《科幻巅峰》合辑上线，20部经典一次看够', tagClass: 'bg-primary-500/20 text-primary-400' },
];

export default function Updates() {
  return (
    <section id="updates" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-4">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            桃子影院更新日志
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            实时追踪桃子影院的最新资源与平台动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/40"></div>

          <div className="space-y-5">
            {updateItems.map((item, index) => (
              <div key={index} className="relative flex items-start gap-5 pl-12">
                <div className={`absolute left-[11px] top-1.5 w-[17px] h-[17px] rounded-full border-2 ${
                  item.tag === '上新' ? 'border-accent-500 bg-accent-500/20' :
                  item.tag === '热播' ? 'border-primary-500 bg-primary-500/20' :
                  'border-secondary-500 bg-secondary-500/20'
                }`}></div>

                <div className="flex-1 bg-background-100 hover:bg-background-200/70 rounded-xl p-4 border border-background-300/20 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${item.tagClass}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}